import { BaseModel } from "sjs-base-model";
import SpendingReviewModel from "./SpendingReviewModel";

export default class VersionSpendingReviewModel extends BaseModel {
    public readonly versionDate: Date | undefined;
    public readonly idVersion: number = 0;
    public readonly spendingReviews: SpendingReviewModel[] = [];

    constructor(data: Partial<VersionSpendingReviewModel>) {
        super();

        this.update(data);
    }
}
